/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import styles from '../styles/Home.module.css';
import { useEffect, useState } from 'react';
import { FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import { trees } from '../config';
import ErrorMessage from '../components/01-atoms/ErrorMessage';
import Loading from '../components/02-molecules/Loading';
import SuspendMessage from '../components/forms/common/SuspendMessage.tsx';
import FROutputCallbackBasedView from '../components/forms/common/FROutputCallBackBasedView';
import { MessageType } from '../components/modals/SuccessErrorModal';
import InviteSuccessPage from './InviteSuccessPage';
import { Navigate } from 'react-router-dom';


const tree = trees.inviteUser;

const InviteUser = () => {
  const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
  const [messageType, setMessageType] = useState(MessageType.error);
  const [message, setMessage] = useState('');  
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  /********methods****************************************** */

 

  useEffect(() => {
    (async function getStep() {
      const id = new URLSearchParams(window.location.search).get('id') || '';
      try {
        const initialStep = await FRAuth.start({ tree, query: { id } });
        setStep(initialStep);
      } catch (err) {
        console.error(`Error: request for initial step; ${err}`);
      }
    })();
  }, []);

  const reloadpage = () => {
    window.location.reload();
  }

  const getInviteUserView = () => {
    let uiElement: JSX.Element = <Loading size={100} />;
    if (step && step.type === StepType.Step) {
      switch (step.getStage()) {
        case 'InviteUser':
          uiElement = (<> 
            <FROutputCallbackBasedView step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/>
          </>);
          break;
        case 'SuspendMessage':
          // uiElement = <SuspendMessage step={step as FRStep} />;
          uiElement = <InviteSuccessPage step={step as FRStep} button={<button className={`accent-1`} style={{ width: '100%',minHeight:"40px",marginTop:"28px" }} onClick={reloadpage}>Invite More Members</button>} header={'MEMBER INVITATION'} description="The following users have been delivered an invite by email to join your company group. Please return to your administrative dashboard tab for additional review." ></InviteSuccessPage>
          break;
      }
    } else if (step && step.type === StepType.LoginFailure) {
      uiElement=<ErrorMessage message={step?.getMessage()} code={step?.getCode()}/>
    }
    return uiElement;

  }
  
  /************************render********************************** */
  return (
    <>
      <div className={styles.container}>
        <main className={styles.main}>{getInviteUserView()}</main>
      </div>
    </>
  );
};

export default InviteUser;
